export default __webpack_public_path__ + "792e3a799df826ffceb78ce047c49e6e.webp";